"use strict";
/*
 * This code was generated by
 * ___ _ _ _ _ _    _ ____    ____ ____ _    ____ ____ _  _ ____ ____ ____ ___ __   __
 *  |  | | | | |    | |  | __ |  | |__| | __ | __ |___ |\ | |___ |__/ |__|  | |  | |__/
 *  |  |_|_| | |___ | |__|    |__| |  | |    |__] |___ | \| |___ |  \ |  |  | |__| |  \
 *
 * Twilio - Messaging
 * This is the public Twilio REST API.
 *
 * NOTE: This class is auto generated by OpenAPI Generator.
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Version_1 = __importDefault(require("../../base/Version"));
const channelsSender_1 = require("./v2/channelsSender");
const domainCerts_1 = require("./v2/domainCerts");
const typingIndicator_1 = require("./v2/typingIndicator");
class V2 extends Version_1.default {
    /**
     * Initialize the V2 version of Messaging
     *
     * @param domain - The Twilio (Twilio.Messaging) domain
     */
    constructor(domain) {
        super(domain, "v2");
    }
    /** Getter for channelsSenders resource */
    get channelsSenders() {
        this._channelsSenders =
            this._channelsSenders || (0, channelsSender_1.ChannelsSenderListInstance)(this);
        return this._channelsSenders;
    }
    /** Getter for domainCerts resource */
    get domainCerts() {
        this._domainCerts = this._domainCerts || (0, domainCerts_1.DomainCertsListInstance)(this);
        return this._domainCerts;
    }
    /** Getter for typingIndicator resource */
    get typingIndicator() {
        this._typingIndicator =
            this._typingIndicator || (0, typingIndicator_1.TypingIndicatorListInstance)(this);
        return this._typingIndicator;
    }
}
exports.default = V2;
